import React from 'react';

import Stack from '@mui/material/Stack';

import { ZoomZoneButton } from 'handimap-react-lib/components/ZoomZoneButton';
import { MaptypeContainer } from 'handimap-react-lib/containers/MaptypeContainer';
import { MapControlComponent } from '../components/MapControlComponents';

export const MapFunctionContainer = () => {
  const styles = {
    container : {
      position: 'absolute',
      right: 5,
      paddingY: '.4em',
      zIndex: 100,
      alignItems: 'flex-end'
    }
  };
  return (
    <Stack sx={styles.container} direction='column' spacing={2}>
      <ZoomZoneButton />
      <MaptypeContainer />
      <MapControlComponent />
    </Stack>
  );
};